<template>
  <PhoneNumber :phone="phone" copyable :data-test="`user-phone-${rowIndex}`" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import PhoneNumber from '@/components/PhoneNumber.vue'

const UserPhoneColumn = graphql(`
  fragment UserPhoneColumn on User {
    id
    phone
  }
`)

const props = defineProps<{
  row: FragmentType<typeof UserPhoneColumn>
  rowIndex?: number
}>()

const phone = computed(() => useFragment(UserPhoneColumn, props.row).phone || null)
const rowIndex = computed(() => props.rowIndex ?? 0)
</script>
